/* Version: 3.5.137 */
'use client';
var LINK_VARIANT = {
  DEFAULT: 'default',
  INVERSE: 'inverse'
};

export { LINK_VARIANT };
